import React, {useEffect, useRef, useState } from 'react';

import './SessionsManager.css';

export default function SessionsManager({device, deviceLinkSocket}) {
    const [previews, setPreviews] = useState({});
    const [sessions, setSessions] = useState([]);
    
    const [editTitles, setEditTitles] = useState({});
    const inputRefs = useRef({});
    const [loading, setLoading] = useState(true);
    
    function setSessionName(session, name){
        setEditTitles(prev => ({...prev, [session.Number]: name}))
    }

    function cancelEdit(session, restoreTitle = false){
        if(restoreTitle && inputRefs.current[session.Number]){
            inputRefs.current[session.Number].value = session.Title;
        }
        
        setEditTitles(prev => {
            const newEditTitles = {...prev};
            delete newEditTitles[session.Number]
            return newEditTitles;
        })
    }

    function saveEdit(session){
        setSessions(prev => prev.map(s => 
            s.Number === session.Number ? {...s, Title: editTitles[s.Number]} : s
        ));

        cancelEdit(session);

        deviceLinkSocket.emit('link_message', {
            token: device.token,
            msg: {
                type: 'set_session', 
                session: {
                    Number: session.Number, 
                    Title: editTitles[session.Number]
                }
            }
        })
    }

    function updateSessions(){
        deviceLinkSocket.emit('link_message', {
            token: device.token,
            msg: {type: 'get_sessions'}
        });
    }

    function processLinkMessage({ from, msg }){
        if (from !== device.id) return;

        if (msg.type === 'sessions') {
            setSessions(msg.sessions);
            setLoading(false);

            if (Object.keys(previews).length === 0){
                deviceLinkSocket.emit('link_message', {
                    token: device.token,
                    msg: {
                        type: 'get_session_previews'
                    }
                });
            }
        }else if (msg.type === 'session-previews') {
            setPreviews(msg.previews);
        }
    }

    useEffect(() => {
        deviceLinkSocket.on('link_message', processLinkMessage);
        updateSessions();

        return () => {
            deviceLinkSocket.off('link_message', processLinkMessage);
        };
    }, [device, deviceLinkSocket]);

    if(!device.online){
        return "Your device is offline. Please run Medicalholodeck on your device.";
    }

    if(!loading && sessions.length === 0){
        return "No sessions found."
    }

    return (
        <div className="sessions" style={{display:'flex', textAlign:'left', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'left'}}>
            {!loading && sessions.map(session => {
                const isBeingEditted = session.Number in editTitles;

                return (
                    <div className="session" key={session.Number}>
                        <div className="data-preview-image" style={{
                        backgroundImage: previews[session.Number] 
                            ? `url(data:image/jpeg;base64,${previews[session.Number]})` 
                            : 'none'
                        }}/>
                        <div className='metadata'>
                            <h3>{session.Title}</h3>
                            { new Date(Number(session.Time)*1000).toLocaleDateString() }
                            <br />
                        </div>
                        <div className="input">
                            <label>Label</label>
                            <input defaultValue={session.Title} ref={element => inputRefs.current[session.Number] = element} style={{maxWidth:'300px'}} type="text" onInput={(e) => {setSessionName(session, e.target.value)}} />
                            {isBeingEditted && <button onClick={e => saveEdit(session)}>Save</button>}
                            {isBeingEditted && <button onClick={e => cancelEdit(session, true)}>Cancel</button>}
                        </div>
                    </div>
                )
            }).reverse()}
        </div>
    );
}